import { useEffect, useState } from "react";
import { getToken } from "../utils/auth";

const API = process.env.REACT_APP_API_URL || "http://localhost:3001";

export default function Usuarios() {
  const [me, setMe] = useState(null);
  const [rede, setRede] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mostrarSenha, setMostrarSenha] = useState(false);
  const [nomeEmpresa, setNomeEmpresa] = useState("");
  const [telefone, setTelefone] = useState("");
  const [role, setRole] = useState("franquia");
  const [loading, setLoading] = useState(false);
  const [excluindoId, setExcluindoId] = useState(null);

  const token = getToken();

  useEffect(() => {
    carregarMe();
    carregarRede();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function carregarMe() {
    try {
      const res = await fetch(`${API}/me`, {
        headers: { Authorization: token },
      });

      const data = await res.json();
      setMe(data);

      if (data.role === "master") setRole("gestor");
      if (data.role === "gestor") setRole("franquia");
      if (data.role === "franquia") setRole("colaborador");
    } catch (err) {
      console.log(err);
      alert("Erro ao carregar usuário.");
    }
  }

  async function carregarRede() {
    try {
      const res = await fetch(`${API}/minha-rede`, {
        headers: { Authorization: token },
      });

      const data = await res.json();
      setRede(data.rede || []);
    } catch (err) {
      console.log(err);
      alert("Erro ao carregar rede.");
    }
  }

  function cargosPermitidos() {
    if (!me) return [];

    if (me.role === "master") {
      return [
        { value: "gestor", label: "Gestor" },
        { value: "franquia", label: "Franquia" },
        { value: "colaborador", label: "Colaborador" },
      ];
    }

    if (me.role === "gestor") {
      return [
        { value: "franquia", label: "Franquia" },
        { value: "colaborador", label: "Colaborador" },
      ];
    }

    if (me.role === "franquia") {
      return [{ value: "colaborador", label: "Colaborador" }];
    }

    return [];
  }

  async function criarUsuario(e) {
    e.preventDefault();

    if (!email || !password || !nomeEmpresa || !role) {
      alert("Preencha todos os campos obrigatórios");
      return;
    }

    if (password.length < 6) {
      alert("A senha precisa ter pelo menos 6 caracteres");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(`${API}/usuarios/criar`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          email,
          password,
          role,
          nomeEmpresa,
          telefone,
        }),
      });

      const data = await res.json();

      if (res.ok) {
        alert("Usuário criado com sucesso 🚀");
        setEmail("");
        setPassword("");
        setMostrarSenha(false);
        setNomeEmpresa("");
        setTelefone("");
        await carregarRede();
      } else {
        alert(data.error || "Erro ao criar usuário");
      }
    } catch (err) {
      console.log(err);
      alert("Erro ao conectar com servidor");
    } finally {
      setLoading(false);
    }
  }

  async function excluirUsuario(user) {
    const confirmar = window.confirm(
      `Tem certeza que deseja excluir este usuário?\n\nEmpresa: ${
        user.nomeEmpresa || "Empresa"
      }\nE-mail: ${user.email}\nCargo: ${nomeCargo(
        user.role
      )}\n\nEssa ação não pode ser desfeita.`
    );

    if (!confirmar) return;

    try {
      setExcluindoId(user.id);

      const res = await fetch(`${API}/usuarios/${user.id}`, {
        method: "DELETE",
        headers: { Authorization: token },
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Erro ao excluir usuário");
        return;
      }

      alert(data.message || "Usuário excluído com sucesso");
      await carregarRede();
    } catch (err) {
      console.log(err);
      alert("Erro ao excluir usuário");
    } finally {
      setExcluindoId(null);
    }
  }

  function nomeCargo(cargo) {
    const nomes = {
      master: "Master",
      gestor: "Gestor",
      franquia: "Franquia",
      colaborador: "Colaborador",
    };

    return nomes[cargo] || cargo;
  }

  if (!me) {
    return <p>Carregando...</p>;
  }

  const permitidos = cargosPermitidos();

  return (
    <>
      <style>{css}</style>

      <div className="usuariosPage">
        <div className="usuariosHeader">
          <div>
            <span className="tagModulo">Gestão de acessos</span>
            <h1>👥 Usuários</h1>
            <p>
              Seu cargo: <strong>{nomeCargo(me.role)}</strong> | Plano:{" "}
              <strong>{me.plano}</strong>
            </p>
          </div>

          <button className="btnAtualizar" onClick={carregarRede}>
            Atualizar lista
          </button>
        </div>

        {permitidos.length === 0 ? (
          <div className="box">
            <h2>Sem permissão</h2>
            <p>Seu usuário não pode criar novos usuários.</p>
          </div>
        ) : (
          <div className="box boxCriar">
            <div className="boxTitleRow">
              <div>
                <h2>Criar novo usuário</h2>
                <p>
                  Cadastre usuários diretamente dentro da sua rede com cargo e
                  acesso correto.
                </p>
              </div>
            </div>

            <form onSubmit={criarUsuario}>
              <div className="formGrid">
                <div className="campo">
                  <label>Nome da empresa *</label>
                  <input
                    type="text"
                    placeholder="Ex: Gestor One Curitiba"
                    value={nomeEmpresa}
                    onChange={(e) => setNomeEmpresa(e.target.value)}
                  />
                </div>

                <div className="campo">
                  <label>E-mail *</label>
                  <input
                    type="email"
                    placeholder="email@empresa.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>

                <div className="campo">
                  <label>Senha *</label>
                  <div className="senhaBox">
                    <input
                      type={mostrarSenha ? "text" : "password"}
                      placeholder="Senha de acesso"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                      type="button"
                      className="btnOlho"
                      onClick={() => setMostrarSenha(!mostrarSenha)}
                      title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                    >
                      {mostrarSenha ? "🙈" : "👁️"}
                    </button>
                  </div>
                </div>

                <div className="campo">
                  <label>Telefone</label>
                  <input
                    type="text"
                    placeholder="(41) 99999-9999"
                    value={telefone}
                    onChange={(e) => setTelefone(e.target.value)}
                  />
                </div>

                <div className="campo">
                  <label>Cargo *</label>
                  <select value={role} onChange={(e) => setRole(e.target.value)}>
                    {permitidos.map((cargo) => (
                      <option key={cargo.value} value={cargo.value}>
                        {cargo.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <button className="btnCriar" disabled={loading}>
                {loading ? "Criando usuário..." : "Criar usuário"}
              </button>
            </form>
          </div>
        )}

        <div className="box">
          <div className="boxTitleRow">
            <div>
              <h2>Minha rede</h2>
              <p>Usuários cadastrados abaixo do seu perfil.</p>
            </div>
          </div>

          {rede.length === 0 ? (
            <p className="textoVazio">Nenhum usuário abaixo de você ainda.</p>
          ) : (
            <div className="listaRede">
              {rede.map((user) => (
                <div key={user.id} className="linhaUsuario">
                  <div className="dadosUsuario">
                    <strong>{user.nomeEmpresa || "Empresa"}</strong>
                    <p>{user.email}</p>
                    <p>{user.telefone || "Sem telefone"}</p>

                    <div className="badges">
                      <span className="badge cargo">{nomeCargo(user.role)}</span>

                      <span
                        className={`badge status ${
                          user.status === "pendente" ? "pendente" : "ativo"
                        }`}
                      >
                        {user.status || "ativo"}
                      </span>

                      <span className="badge plano">
                        {user.assinatura?.status === "beta"
                          ? "Beta gratuito"
                          : user.assinatura?.status || "Sem assinatura"}
                      </span>
                    </div>
                  </div>

                  <div className="acoesUsuario">
                    <button
                      className="btnExcluir"
                      onClick={() => excluirUsuario(user)}
                      disabled={excluindoId === user.id}
                    >
                      {excluindoId === user.id ? "Excluindo..." : "Excluir"}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

const css = `
.usuariosPage {
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding-bottom: 40px;
  overflow-x: hidden;
}

.usuariosHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 22px;
}

.tagModulo {
  display: inline-flex;
  padding: 7px 11px;
  border-radius: 999px;
  background: #dbeafe;
  color: #1e40af;
  font-size: 12px;
  font-weight: 900;
  margin-bottom: 10px;
}

.usuariosHeader h1 {
  margin: 0;
  color: #0f172a;
  font-size: clamp(30px, 6vw, 44px);
  font-weight: 900;
  letter-spacing: -0.04em;
}

.usuariosHeader p {
  margin: 8px 0 0;
  color: #64748b;
}

.box {
  background: #f8fafc;
  padding: 24px;
  border-radius: 22px;
  margin-bottom: 24px;
  box-shadow: 0 14px 34px rgba(15, 23, 42, 0.08);
  max-width: 100%;
  overflow-x: hidden;
  border: 1px solid #e2e8f0;
}

.boxCriar {
  background: linear-gradient(180deg, #ffffff, #f8fafc);
}

.boxTitleRow {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
}

.box h2 {
  margin: 0;
  color: #0f172a;
  font-size: 24px;
  font-weight: 900;
}

.boxTitleRow p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 14px;
}

.formGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
  width: 100%;
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.campo label {
  color: #334155;
  font-size: 13px;
  font-weight: 900;
}

.campo input,
.campo select,
.senhaBox {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  border-radius: 14px;
  border: 1px solid #cbd5e1;
  outline: none;
  font-size: 15px;
  background: white;
}

.campo input,
.campo select {
  padding: 14px 14px;
}

.campo input:focus,
.campo select:focus,
.senhaBox:focus-within {
  border-color: #2563eb;
  box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
}

.senhaBox {
  display: flex;
  align-items: center;
  overflow: hidden;
}

.senhaBox input {
  border: none;
  box-shadow: none;
  border-radius: 0;
  flex: 1;
  min-width: 0;
}

.senhaBox input:focus {
  box-shadow: none;
}

.btnOlho {
  border: none;
  background: #f1f5f9;
  min-height: 100%;
  align-self: stretch;
  padding: 0 15px;
  cursor: pointer;
  font-size: 17px;
  border-left: 1px solid #e2e8f0;
}

.btnOlho:hover {
  background: #e0f2fe;
}

.btnCriar,
.btnAtualizar {
  border: none;
  border-radius: 15px;
  color: white;
  font-weight: 900;
  cursor: pointer;
  transition: 0.2s;
}

.btnCriar {
  padding: 14px 24px;
  background: linear-gradient(135deg, #0f172a, #020617);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.22);
}

.btnAtualizar {
  padding: 13px 18px;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  box-shadow: 0 10px 24px rgba(37, 99, 235, 0.25);
}

.btnCriar:hover,
.btnAtualizar:hover,
.btnExcluir:hover {
  transform: translateY(-1px);
}

.btnCriar:disabled,
.btnAtualizar:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}

.listaRede {
  display: grid;
  gap: 12px;
}

.linhaUsuario {
  background: white;
  padding: 18px;
  border-radius: 18px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
  border: 1px solid #eef2f7;
  max-width: 100%;
}

.dadosUsuario {
  min-width: 0;
}

.dadosUsuario strong {
  display: block;
  color: #0f172a;
  font-size: 17px;
  margin-bottom: 5px;
}

.dadosUsuario p {
  margin: 0;
  color: #64748b;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.badges {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
}

.badge {
  display: inline-flex;
  align-items: center;
  padding: 5px 9px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 900;
}

.badge.cargo {
  background: #dbeafe;
  color: #1e40af;
}

.badge.status.ativo {
  background: #dcfce7;
  color: #166534;
}

.badge.status.pendente {
  background: #fef3c7;
  color: #92400e;
}

.badge.plano {
  background: #f1f5f9;
  color: #334155;
}

.acoesUsuario {
  display: flex;
  justify-content: flex-end;
}

.btnExcluir {
  border: none;
  background: linear-gradient(135deg, #ef4444, #b91c1c);
  color: white;
  padding: 11px 15px;
  border-radius: 13px;
  font-weight: 900;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 10px 22px rgba(239, 68, 68, 0.22);
}

.btnExcluir:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.textoVazio {
  color: #64748b;
}

@media (max-width: 900px) {
  .formGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .usuariosPage {
    overflow-x: hidden;
  }

  .usuariosHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .btnAtualizar {
    width: 100%;
    min-height: 50px;
  }

  .box {
    padding: 18px;
    border-radius: 18px;
  }

  .boxTitleRow {
    flex-direction: column;
  }

  .formGrid {
    grid-template-columns: 1fr;
  }

  .btnCriar {
    width: 100%;
    min-height: 52px;
  }

  .linhaUsuario {
    grid-template-columns: 1fr;
    align-items: stretch;
    padding: 16px;
  }

  .acoesUsuario {
    justify-content: stretch;
  }

  .btnExcluir {
    width: 100%;
    min-height: 46px;
  }
}

@media (max-width: 390px) {
  .box {
    padding: 15px;
  }

  .usuariosHeader h1 {
    font-size: 29px;
  }
}
`;
